import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { VoiceCatalogBorder, ListItemBackground } from "shared/constants";

export interface LanguageItemProps {
  languageInfo: {
    value: string;
    name: string;
    icon: string;
  };
  handleLanguageSelection: () => void;
  isSelected: boolean;
  padding?: string;
}

export default function LanguageItem({
  languageInfo,
  handleLanguageSelection,
  isSelected,
  padding = "8px 16px",
}: LanguageItemProps): JSX.Element {
  return (
    <ListItem
      key={languageInfo.value}
      id={languageInfo.value}
      sx={{
        cursor: "pointer",
        border: isSelected
          ? `1px solid ${VoiceCatalogBorder.Selected}`
          : `1px solid transparent`,
        "&:hover": {
          backgroundColor: isSelected ? "" : "rgba(0, 0, 0, 0.04)",
          border: "",
        },
        backgroundColor: isSelected ? ListItemBackground.Selected : "white",
        padding,
        "@media (max-width:600px)": {
          padding: "16px",
        },
      }}
      onClick={handleLanguageSelection}
      secondaryAction={
        isSelected && <CheckIcon sx={{ color: "primary.main" }} />
      }
    >
      <ListItemIcon>
        <Stack
          sx={{
            backgroundColor: "#BDBDBD",
            borderRadius: "64px",
          }}
        >
          <img
            width="35px"
            height="35px"
            src={languageInfo.icon}
            srcSet={languageInfo.icon}
            id={`languages.name.${languageInfo.name}`}
            alt={languageInfo.name}
            loading="lazy"
          />
        </Stack>
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography variant="subtitle2" color="text.primary">
            {languageInfo.name}
          </Typography>
        }
      />
    </ListItem>
  );
}
